'use client';
import { useState, type FormEvent } from 'react';
import { signIn } from 'next-auth/react';
import '../fly.css';

export default function FlyLogin() {
  const [error,setError]=useState('');const [pending,setPending]=useState(false);
  async function submit(event:FormEvent<HTMLFormElement>) {
    event.preventDefault();setPending(true);setError('');
    const form=new FormData(event.currentTarget);
    try {
      const result=await signIn('credentials',{email:form.get('email'),password:form.get('password'),totpCode:form.get('totpCode'),redirect:false});
      if(result?.error)setError('Sign-in failed. Check your email, password, and authenticator code.');
      else window.location.assign('/fly');
    } catch {setError('Unable to connect. Please try again.');} finally {setPending(false);}
  }
  return <main className="fly-root" style={{minHeight:'100vh',display:'grid',placeItems:'center',background:'#f5f4f2',padding:24}}>
    <section style={{width:'min(440px,100%)',padding:40,background:'white',border:'1px solid #e5e2df',borderRadius:18,boxShadow:'0 20px 60px #16131b0a'}}>
      <div style={{color:'#ed1c24',fontWeight:900,fontSize:32,letterSpacing:-1}}>FLY</div>
      <h1 style={{fontSize:26,fontWeight:700,margin:'16px 0 8px'}}>Welcome to WorkSuite</h1>
      <p style={{color:'#67616a',marginBottom:28}}>Your brands. Your clients. One workspace.</p>
      <form onSubmit={submit} style={{display:'grid',gap:16}}>
        <label>Email<input name="email" type="email" required autoComplete="username" style={{display:'block',width:'100%',border:'1px solid #ccc',borderRadius:8,padding:12,marginTop:6}} /></label>
        <label>Password<input name="password" type="password" required autoComplete="current-password" style={{display:'block',width:'100%',border:'1px solid #ccc',borderRadius:8,padding:12,marginTop:6}} /></label>
        <label>Authenticator code <span style={{color:'#777'}}>(if enabled)</span><input name="totpCode" inputMode="numeric" autoComplete="one-time-code" maxLength={6} style={{display:'block',width:'100%',border:'1px solid #ccc',borderRadius:8,padding:12,marginTop:6}} /></label>
        {error&&<p role="alert" style={{color:'#b01224'}}>{error}</p>}
        <button disabled={pending} style={{padding:13,borderRadius:8,background:'#bd1520',color:'white',fontWeight:700}}>{pending?'Signing in…':'Sign in'}</button>
      </form>
      <p style={{fontSize:12,color:'#777',marginTop:22}}>Private development environment</p>
    </section>
  </main>;
}
